import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import CourseChapter from 'src/model/CourseChapter';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import GenericError from 'src/component/GenericError';
import useListCourseLesson from 'src/hook/CourseLessonHook';
import CourseLesson from 'src/model/CourseLesson';
import { Link } from 'react-router-dom';

export interface CourseChapterAccordionProps {
  courseChapter: CourseChapter;
}

export default function CourseChapterAccordion(props: CourseChapterAccordionProps) {
  const { courseChapter } = props;
  const [errorState, setError] = useState(false);
  const courseLessonsState: Array<CourseLesson> = useListCourseLesson(
    setError,
    courseChapter.courseChapterId,
  );
  const courseLessonsListItems = courseLessonsState.map((courseLesson) => (
    <ListItem disablePadding key={courseLesson.courseLessonId}>
      <ListItemButton
        component={Link}
        to={`/course/${courseChapter.courseId}/${courseChapter.courseChapterId}/${courseLesson.courseLessonId}`}
      >
        <ListItemText primary={courseLesson.title} />
      </ListItemButton>
    </ListItem>
  ));

  if (errorState) {
    return <GenericError errorMessage="" />;
  }
  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>{courseChapter.title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List>{courseLessonsListItems}</List>
      </AccordionDetails>
    </Accordion>
  );
}
